import React, { PropsWithChildren } from 'react';

import { HelmetTags, MainLayout } from '~/components';

import { ClassPageContent } from './ClassPageContent';
import { Content } from './types';

type PageViewData = React.ComponentProps<typeof MainLayout>['pageViewData'];

interface Props {
  content: Content;
}

// MainLayout separated to support `useShouldRenderPaywallExperiment`
export const ClassPage: React.FC<PropsWithChildren<Props>> = ({ content }) => {
  const { title, id, entry_date, teacher, media_duration, style, level } = content;
  const pageViewData: PageViewData = {
    contentChannel: 'Yoga',
    contentTopic: 'Class',
    contentAuthor: teacher.full_name,
    contentPubDate: entry_date.yyyymmdd,
    contentTitle: title,
    contentId: id,
    contentClassDuration: media_duration ? media_duration.group : '',
    contentClassStyle: style[0]?.name || '',
    contentClassLevel: level[0]?.name || '',
  };

  const {
    seo_title,
    seo_description,
    entry_type,
    short_summary,
    full_url,
    no_text_image: { processed_url },
  } = content;
  return (
    <MainLayout pageTitle={title} pageViewData={pageViewData}>
      <HelmetTags
        entry_type={entry_type}
        teacherName={teacher.full_name}
        short_summary={short_summary}
        title={title}
        seo_title={seo_title}
        seo_description={seo_description}
        media_duration={media_duration}
        entry_date={entry_date}
        url={full_url}
        image_url={processed_url}
      />
      <ClassPageContent content={content} />
    </MainLayout>
  );
};
